import styled from '@emotion/styled';
import { themeGet } from 'styled-system';
import { rem } from 'polished';
import { Box, Flex, Link, NakedButton } from 'roo-ui/components';

export const DrawerContainer = styled(Box)`
  display: ${(props) => (props.isOpen ? 'block' : `none`)};
`;

export const Drawer = styled(Box)`
  overflow: scroll;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  transition: all 0.2s ease-in-out;
  color: ${themeGet('colors.white')};
  z-index: ${themeGet('zIndices.phoneMenuDrawer')};
  right: ${themeGet('uiStructure.phoneMenuDrawerCloseWidth')};
  background-color: ${themeGet('colors.greys.charcoal')};
  will-change: transform;
  opacity: ${(props) => (props.isOpen ? '1' : '0')};
  transform: translateX(${(props) => (props.isOpen ? '0' : `-100%`)});
`;

export const DrawerClose = styled(Flex)`
  justify-content: center;
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  overflow: hidden;
  flex-direction: row;
  align-items: flex-start;
  transition: all 0.2s ease-in-out;
  color: ${themeGet('colors.white')};
  width: ${themeGet('uiStructure.phoneMenuDrawerCloseWidth')};
  background-color: ${themeGet('colors.brand.primary')};
  z-index: ${themeGet('zIndices.phoneMenuDrawer')};
  visibility: ${(props) => (props.isOpen ? 'visible' : 'hidden')};
  opacity: ${(props) => (props.isOpen ? '1' : '0')};
`;

export const MenuButton = styled(NakedButton)`
  cursor: pointer;
  width: ${themeGet('uiStructure.phoneMenuDrawerCloseWidth')};
  margin-right: ${themeGet('space.1')};
  padding: ${rem('22px')} 0;
`;

export const PhoneMenuLink = styled(Link)`
  display: block;
  padding: ${themeGet('space.4')} ${themeGet('space.5')};
  color: ${themeGet('colors.white')};
  border-bottom: 1px solid ${themeGet('colors.white')};
  &:hover {
    color: ${themeGet('colors.white')};
  }
`;
